import React, { useState, useEffect } from "react";
import GUIset_Single from "./gui/GUIset_Single";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const Kadane = () => {
	useEffect(() => {
		document.title = "Maximum Subarray Sum: Kadane’s Algorithm";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState(
		"1,-3,2,1,-1,5,3,4,-5,-9,1,3,4,8,7,2,1,-2,3,-4,-4,9,9"
	);
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			var arr0 = T.str_toListInt(guiTxt1);
			//
			Timer.start();
			process(arr0);
			txt_time = Timer.stop_print();
			//---------
			BuildResult();
		}
	};

	var txt_time = "";
	var txt_result1 = "";
	var txt_result2 = "";

	function process(arr0) {
		var r = kadane(arr0);
		console.log("# of set " + r);
	}

	function kadane(arr) {
		var i_begin = 0;
		var i_end = 0;
		var max_current = arr[0];
		var max_global = arr[0];
		for (var i = 1; i < arr.length; i++) {
			var newSum = max_current + arr[i];
			if (arr[i] >= newSum) {
				i_begin = i;
			}
			max_current = Math.max(arr[i], newSum);
			if (max_current > max_global) {
				max_global = max_current;
				i_end = i;
			}
		}
		txt_result1 = "Max = " + max_global + " (index " + i_begin + " to " + i_end + ")";
		console.log(txt_result1);
		var str = "[";
		for (var i = i_begin; i <= i_end; i++) {
			if (str != "[") {
				str += ",";
			}
			str += arr[i];
		}
		str += "]";
		txt_result2 = "Subarray: " + str;
		console.log(txt_result2);
	}

	function BuildResult() {
		var txt = txt_time + "\n" + txt_result1 + "\n" + txt_result2;	
		partResultChange(Template.simple01("key1","Result",txt,22,22));
	}

	return (
		<GUIset_Single
			title={"Kadane's Algorithm to Maximum Sum Subarray Problem"}
			desc={
				"Given an array of integers, find the maximum subarray sum possible of all the non-empty subarrays."
			}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			guiTxt={guiTxt1}
			partResult={partResult}
			label1={"Array"}
			isNumOnly = {false}
			txtButton={"Analyze"}
		/>
	);
};

export default Kadane;




// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";





		// partResultChange(
		// 	<div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Result</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_time}</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result1}</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result2}</div>
		// 	</div>
		// );





		// <div className="todoapp stack-large">
		// 	<GUI_Header
		// 		title={"Kadane's Algorithm to Maximum Sum Subarray Problem"}
		// 		desc={
		// 			"Given an array of integers, find the maximum subarray sum possible of all the non-empty subarrays."
		// 		}
		// 	/>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	<GUI_InputTextSingle
		// 		label={"Array"}
		// 		text1={guiTxt2}
		// 		text1Change={guiTxtChange2}
		// 		numberOnly={false}
		// 		fontSize2={24}
		// 		width1={100}
		// 		width2={'100%'}
		// 	/>
		// 	<div style={{ display: "flex", marginLeft: '14%',marginRight: 0 }}>
		// 		<button
		// 			onClick={() => buttonClick1()}
		// 			className="btn btn__primary btn__lg"
		// 			style={{ flex: 1, height: 50 }}
		// 		>
		// 			Calculate
		// 		</button>
		// 	</div>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	{partResult}
		// 	<GUI_Credit />
		// </div>